function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "bx-reset",
  transform: "translate(-4.5 -3)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_32050",
  "data-name": "Path 32050",
  d: "M19.667,27.333A6.167,6.167,0,1,0,13.5,21.167,6.132,6.132,0,0,0,19.667,27.333Z",
  transform: "translate(3.333 4.444)",
  fill: "#8b8c8e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_32051",
  "data-name": "Path 32051",
  d: "M41.125,21.882a18.377,18.377,0,0,0-2.785-6.618,18.61,18.61,0,0,0-5-4.995,18.34,18.34,0,0,0-10.4-3.155V3L14.778,9.167l8.172,6.167V11.226a14.395,14.395,0,0,1,13.31,19.985,14.615,14.615,0,0,1-1.325,2.444,14.8,14.8,0,0,1-1.764,2.135A14.446,14.446,0,0,1,25.9,39.711a14.656,14.656,0,0,1-5.8,0,14.4,14.4,0,0,1-11.491-14.1H4.5a18.5,18.5,0,0,0,28.844,15.34,18.265,18.265,0,0,0,2.735-2.258,18.969,18.969,0,0,0,2.261-2.738A18.4,18.4,0,0,0,41.5,25.611a18.689,18.689,0,0,0-.376-3.731Z",
  transform: "translate(0 0)",
  fill: "#8b8c8e"
}));
function SvgBxReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 41.111,
    viewBox: "0 0 37 41.111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxReset);
export default __webpack_public_path__ + "static/media/bx-reset.a439410f.svg";
export { ForwardRef as ReactComponent };